import { classNames } from "src/helpers/classNames";
import { useState, useEffect } from "react";
import { useAppSelector } from "src/hooks/redux";
import { selectItem } from "src/modules/spItems/selectors";
import { myDocumentsListName, versionsByDocumentListName } from "src/api/config";
import { docStatuses } from "src/api/config/systemSwitch";

type Props = {
    activeTabKey: string;
    setActiveTabKey: (str: string) => void;
    documentCardID: any;
    versionView: any;
    card: any;
}

export default function TabsCard(props: Props) {

    const { activeTabKey, setActiveTabKey, documentCardID, versionView, card } = props;

    const [tabs, setTabs] = useState<any>({
        card: { name: 'Карточка', href: '#' },
        approvers: { name: 'Цепочка согласующих', href: '#' },
        history: { name: 'История', href: '#' },
        versions: { name: 'Версии', href: '#' }
    });

    useEffect(() => {
        if (card && (card.Status.get_lookupId() === docStatuses.public || card.Status.get_lookupId() === docStatuses.review)) {
            setTabs((prevState: any) => {
                return { ...prevState, copies: { name: 'Копии', href: '#', current: false }, lists: { name: 'Листы ознакомления', href: '#', current: false } }
            });
        } else {
            const tempTabs = { ...tabs };
            if (tempTabs.hasOwnProperty('lists')) {
                delete tempTabs['lists'];
                setTabs((prevState: any) => {
                    return { ...tempTabs }
                });
            }
            if (tempTabs.hasOwnProperty('copies')) {
                delete tempTabs['copies'];
                setTabs((prevState: any) => {
                    return { ...tempTabs }
                });
            }
        }
    }, [JSON.stringify(card)]);

    useEffect(() => {
        setActiveTabKey("card");
    }, [documentCardID, versionView]);

    return (
        <div className="border-b border-gray-200 mb-6 tablet:mb-10">
            <nav className="-mb-px flex space-x-[10px] tablet:space-x-8 scrollbar-none overflow-x-auto tablet:overflow-x-hidden">
                {Object.keys(tabs).map((key) => (
                    <>
                        {tabs[key] &&
                            <a
                                key={tabs[key].name}
                                href={tabs[key].href}
                                onClick={(e) => {
                                    e.preventDefault();
                                    let tabsTemp = { ...tabs };
                                    Object.keys(tabsTemp).map(innerKey => {
                                        tabsTemp = { ...tabsTemp, [innerKey]: { ...tabs[innerKey], current: false } }
                                    });
                                    setTabs((prevState: any) => {
                                        return { ...prevState, ...tabsTemp }
                                    });
                                    setActiveTabKey(key);
                                }}
                                className={classNames(
                                    key === activeTabKey
                                        ? 'border-[#012169] text-[#012169]'
                                        : 'border-transparent text-[#637381] hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
                                )}
                            >
                                {tabs[key].name}
                            </a >
                        }
                    </>
                ))}
            </nav>
        </div >
    )
}
